import { getCookieValue } from 'utils/cookies';
import { getItem, setItem } from 'utils/localStorage';

import { getApplicationContext } from './getApplicationContext';

let experiments: string | undefined;
export function setWindowDataLayerExperiments(
  newExperiments: string | undefined,
) {
  experiments = newExperiments;
}

export function windowDataLayerPush(baseEventData: Record<string, unknown>) {
  const eventData = {
    ...baseEventData,
    application_context: getApplicationContext(),
    experiments,
  };

  if (getCookieValue('_traceAnalytics')) {
    const trace = getItem('_analyticsTrace') || [];
    trace.push(eventData);
    setItem('_analyticsTrace', trace);
  }

  // @ts-expect-error TS(2339): Property 'dataLayer' does not exist on type 'Windo... Remove this comment to see the full error message
  window.dataLayer.push(eventData);
}
